import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { Observable, of } from 'rxjs';

import { Perk } from 'src/app/interfaces/perk';
import { PerkService } from '../perk/perk.service';

@Injectable({
  providedIn: 'root'
})
export class PerksResolverService implements Resolve<Perk[] | null> {

  constructor(private perkService: PerkService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Perk[] | null> {
    if (route.parent && route.parent.data && route.parent.data.user) {
      return this.perkService.getPerks();
    }
  
    return of(null);
  }
}
